import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiDownload,
  FiRefreshCw,
  FiXCircle,
  FiClock,
  FiDollarSign,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function Subscriptions() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [subscriptions] = useState([
    {
      id: 1,
      subscriptionId: "SUB-001",
      userId: "USR-001",
      userName: "Rajesh Kumar",
      planName: "Premium Plan",
      startDate: "2024-01-01",
      expiryDate: "2024-02-01",
      status: "Active",
      autoRenewal: true,
      amount: 2499,
    },
    {
      id: 2,
      subscriptionId: "SUB-002",
      userId: "USR-002",
      userName: "Priya Sharma",
      planName: "Basic Plan",
      startDate: "2024-01-15",
      expiryDate: "2024-02-15",
      status: "Active",
      autoRenewal: false,
      amount: 999,
    },
    {
      id: 3,
      subscriptionId: "SUB-003",
      userId: "USR-003",
      userName: "Amit Patel",
      planName: "Premium Plan",
      startDate: "2023-12-01",
      expiryDate: "2024-01-01",
      status: "Expired",
      autoRenewal: false,
      amount: 2499,
    },
  ]);

  const handleExtend = (subscriptionId) => {
    Swal.fire({
      title: "Extend Subscription",
      html: `
        <input id="extensionDays" class="swal2-input" type="number" placeholder="Extension days" required>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Extend",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Extended!", `Subscription extended by ${result.value} days.`, "success");
      }
    });
  };

  const handleRefund = (subscriptionId) => {
    Swal.fire({
      title: "Process Refund?",
      text: "This will process a refund according to the refund policy.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Process Refund",
      confirmButtonColor: "#ef4444",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Refund Processed!", "Refund has been processed successfully.", "success");
      }
    });
  };

  const handleToggleAutoRenewal = (subscriptionId, currentStatus) => {
    Swal.fire({
      title: `${currentStatus ? "Disable" : "Enable"} Auto-Renewal?`,
      text: `Auto-renewal will be ${currentStatus ? "disabled" : "enabled"}.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Yes, ${currentStatus ? "Disable" : "Enable"}`,
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Updated!", `Auto-renewal ${currentStatus ? "disabled" : "enabled"}.`, "success");
      }
    });
  };

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const filteredSubscriptions = subscriptions.filter((subscription) => {
    const matchesSearch =
      subscription.subscriptionId.includes(searchTerm) ||
      subscription.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      subscription.planName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || subscription.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSubscriptions.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredSubscriptions.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                   <div className="content-page-header content-page-headersplit">
                <h5>Subscriptions</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/research/subscriptions">Research</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Subscriptions
                  </li>
                </ol>
              </nav>
         
          
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                  <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by subscription ID, user name, or plan..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Active">Active</option>
                    <option value="Expired">Expired</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                <button className="btn btn-primary">
                  Export
                </button>
              </div>
              </div>
            </div>

            {/* Subscriptions Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Subscription ID</th>
                          <th>User</th>
                          <th>Plan</th>
                          <th>Amount</th>
                          <th>Start Date</th>
                          <th>Expiry Date</th>
                          <th>Status</th>
                          <th>Auto-Renewal</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="9">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((subscription) => (
                            <tr key={subscription.id}>
                              <td style={{ fontWeight: "500" }}>{subscription.subscriptionId}</td>
                              <td style={{ fontWeight: "500" }}>{subscription.userName}</td>
                              <td>{subscription.planName}</td>
                              <td style={{ fontWeight: "600" }}>{formatINR(subscription.amount)}</td>
                              <td>{subscription.startDate}</td>
                              <td style={{ color: subscription.status === "Expired" ? "#ef4444" : "#64748b" }}>
                                {subscription.expiryDate}
                              </td>
                              <td>
                                <span className={subscription.status === "Active" ? "badge-active" : "badge-pending"}>
                                  {subscription.status}
                                </span>
                              </td>
                              <td>
                                <span className={subscription.autoRenewal ? "badge-active" : "badge-pending"}>
                                  {subscription.autoRenewal ? "Yes" : "No"}
                                </span>
                              </td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  {subscription.status === "Active" && (
                                    <>
                                      <button
                                        className="btn btn-sm me-2"
                                        style={{
                                          background: "#ccf1f7",
                                          color: "#006e82",
                                          border: "none",
                                          borderRadius: "6px",
                                          padding: "4px 12px",
                                          fontSize: "12px",
                                        }}
                                        onClick={() => handleExtend(subscription.subscriptionId)}
                                        title="Extend Subscription"
                                      >
                                        {/* <FiClock style={{ fontSize: "14px", marginRight: "4px" }} /> */}
                                        Extend
                                      </button>
                                      <div
                                        className="delete-table me-2"
                                        onClick={() => handleToggleAutoRenewal(subscription.subscriptionId, subscription.autoRenewal)}
                                        title="Toggle Auto-Renewal"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i className="fas fa-redo"></i>
                                      </div>
                                    </>
                                  )}
                                  <div
                                    className="delete-table"
                                    onClick={() => handleRefund(subscription.subscriptionId)}
                                    title="Process Refund"
                                    style={{ cursor: "pointer", color: "#ef4444" }}
                                  >
                                    <i className="fas fa-dollar-sign"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
